<div>
  <h4 class="mb-1">
    {{ severityLabel ?? (findingSeverity | translate) }}
  </h4>
  <div class="d-flex align-items-center">
    <div class="aging-issues-number h1 m-0" data-test-id="aging-issues-number">{{ agingIssues ?? 0 | compactNumber }}</div>
  </div>
  <div>
    @if (severityTimeInterval === 1) {
      <span
        data-test-id="aged_unresolved_findings_day"
        [innerHTML]="'aged_unresolved_findings_day' | translateHtml: [severityTimeInterval]"
      ></span>
    }
    @if (severityTimeInterval !== 1) {
      <span
        data-test-id="aged_unresolved_findings_day"
        [innerHTML]="'aged_unresolved_findings_days' | translateHtml: [severityTimeInterval]"
      ></span>
    }
    @if (agingIssues > 0) {
      <ds-icon
        class="m-2 overdue-findings-icon"
        data-test-id="overdue-findings-icon"
        tabindex="0"
        [icon]="Icons.Flag"
        [iconStyle]="IconStyles.Solid"
        [tooltipPlacement]="DsTooltipPosition.top"
        [ds-tooltip]="'policy_violated' | translate"
        [attr.aria-label]="'policy_violated' | translate"
        [style.color]="EapColors.RedError"
      ></ds-icon>
    }
  </div>
  @if (scanId && agingIssues) {
    <div class="mb-3">
      <a
        data-test-id="overdue-findings-link"
        [routerLink]="['/', Api.manual_evaluations, scanId, Api.results]"
        [queryParams]="{
          evaluationStandard: standard,
          status: auditFindingQAStatusUnresolved().join(','),
          severity: severity[findingSeverity],
          age: severityTimeInterval,
        }"
      >
        {{ 'view_findings' | translate }}
      </a>
    </div>
  }
</div>
